import './index.css';
const Footer = () => {
	return (
		<footer>
			<div
				className='Footer'
				onClick={() => {
					const classBtn = document.getElementById('footer').className;
					switch (classBtn) {
						case 'Footer Footer_Unselected':
							document.getElementById('footer').classList.remove('Footer_Unselected');
							document.getElementById('footer').classList.add('Footer_Selected');
							break;

						default:
							document.getElementById('footer').classList.remove('Footer_Selected');
							document.getElementById('footer').classList.add('Footer_Unselected');
							break;
					}
				}}
				id='footer__fancy'
			>
				<div className='Footer Footer_Unselected' id='footer'>
					<span>
						<a href='https://github.com/malkavianson' target='_blank' rel='noreferrer'>
							@malkavianson
						</a>
					</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
